import {
  Grid,
  Tooltip,
  withStyles,
  WithStyles,
  withWidth
} from '@material-ui/core'
import { WithWidth } from '@material-ui/core/withWidth'
import { ObjectFitProperty } from 'csstype'
import i18n from 'i18next'
import DeleteCircleIcon from 'mdi-react/DeleteCircleIcon'
import { Component } from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import { isSmallScreen } from '../../../libs/screenSize'
import { BucketObject } from '../../../services/storage/types'
import { ApartmentMedia } from '../../../types/apartments'
import { ImageFileWithObjectURL } from '../../../types/files'

const styles = () => ({
  root: {
    maxWidth: '100%',
    padding: '0px 0px 25px 0px'
  },
  rightArrow: {
    display: 'block',
    background: 'grey',
    borderRadius: '40px'
  },
  leftArrow: {
    display: 'block',
    background: 'grey',
    borderRadius: '40px'
  },
  removeIcon: {
    zIndex: '99999' as any,
    position: 'absolute' as any,
    top: '0px',
    right: '10px',
    cursor: 'pointer',
    paddingTop: 8
  },
  imageContainer: {
    position: 'relative' as any
  }
})

// const RightArrow = ({ className, style, onClick, props: { classes } }: any) => (
//   <div
//     className={classNames(className, classes.rightArrow)}
//     style={{
//       ...style,
//       background: 'grey'
//     }}
//     onClick={onClick}
//   />
// )

// const LeftArrow = ({ className, style, onClick, props: { classes } }: any) => (
//   <div
//     className={classNames(className, classes.leftArrow)}
//     style={{
//       ...style,
//       background: 'grey'
//     }}
//     onClick={onClick}
//   />
// )

export const isBucketObject = (
  file: BucketObject | ImageFileWithObjectURL
): file is BucketObject => (file as BucketObject)?.url !== undefined

type MediaFile = BucketObject | ImageFileWithObjectURL

interface MediaProps extends WithStyles, WithWidth {
  files: MediaFile[] | undefined
  media?: ApartmentMedia
  withDelete?: { deleteMedia: (arg: any) => any }
  slidesToShow?: number
  t: i18n.TFunction
  /** css height property */
  imageHeight?: string
  /** css width property */
  imageWidth?: string
  /**  objectFit property */
  imageFit?: ObjectFitProperty
  /** css background property */
  imageBackground?: string
}

class MediaSlider extends Component<MediaProps> {
  slideAmount = (slidesToShow?: number) => slidesToShow || 1

  slidesToShow = () => {
    const slideAmount = this.slideAmount(this.props.slidesToShow)
    const isNormalScreen = !isSmallScreen(this.props.width)
    const slidesToShow =
      this.props.files &&
      this.props.files.length >= slideAmount &&
      isNormalScreen
        ? slideAmount
        : 1

    return slidesToShow
  }

  render() {
    const {
      files,
      media,
      slidesToShow,
      withDelete,
      t,
      classes,
      imageHeight,
      imageWidth,
      imageFit,
      imageBackground
    } = this.props
    const settings = {
      dots: true,
      infinite: files && files.length >= this.slideAmount(slidesToShow),
      speed: 500,
      slidesToShow: this.slidesToShow(),
      slidesToScroll: this.slidesToShow(),
      // nextArrow: <RightArrow props={this.props} />,
      // prevArrow: <LeftArrow props={this.props} />,
      adaptiveHeight: true
    }

    let sortedFiles: (BucketObject | ImageFileWithObjectURL)[] = files || []
    if (Array.isArray(media) && Array.isArray(files) && media.length) {
      sortedFiles = media
        .map((mediaItem) => {
          return (
            files.find((file) => file.key === mediaItem.key) ||
            ({} as BucketObject)
          )
        })
        .filter((file) => !!file.key)
    }

    return (
      <Grid className={classes.root}>
        {sortedFiles && sortedFiles.length > 0 && (
          <Slider {...settings}>
            {sortedFiles.map((file) => (
              <Grid key={file.key} className={classes.imageContainer}>
                {withDelete && (
                  <Tooltip title={`${t('apartment.mediaUpload.delete')}`}>
                    <span
                      className={classes.removeIcon}
                      onClick={() =>
                        withDelete && withDelete.deleteMedia(file.key)
                      }
                    >
                      <DeleteCircleIcon size={40} color='red' />
                    </span>
                  </Tooltip>
                )}
                <img
                  style={{
                    maxHeight: '2000px',
                    height: imageHeight || undefined,
                    width: imageWidth || '100%',
                    margin: '0 auto',
                    objectFit: imageFit || 'contain',
                    background: imageBackground || undefined
                  }}
                  className={classes.image}
                  src={isBucketObject(file) ? file.url : file.key}
                  alt={isBucketObject(file) ? file.key : file.path}
                />
              </Grid>
            ))}
          </Slider>
        )}
      </Grid>
    )
  }
}

export default withStyles(styles)(withWidth()(MediaSlider))
